import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import './AuthForm.css';

function VerifyOtp() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || '';
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);
    try {
      const { error: verifyError, data: verifyData } = await supabase.auth.verifyOtp({
        email,
        token: otp,
        type: 'email',
      });
      if (verifyError) {
        setError('Invalid or expired OTP code. Please check your email and try again.');
        setLoading(false);
        return;
      }
      // Insert profile as resident
      const user = supabase.auth.getUser();
      const userId = user?.id || user?.user?.id; // depends on SDK version

      const { error: profileError } = await supabase
        .from('profiles')
        .insert({ user_id: userId, email, role: 'resident' });
      if (profileError) {
        setError('Verification succeeded, but failed to create profile. Please contact support.');
        setLoading(false);
        return;
      }
      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 1800);
    } catch (err) {
      setError('Verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div 
        className="auth-logo-absolute"
        onClick={() => navigate('/')}
        style={{ cursor: 'pointer' }}
        title="Go to Homepage"
      >
        <img src="/GabaySakunaLogo.svg" alt="Gabay Sakuna Logo" className="auth-logo" />
        <span className="auth-title-main">GabaySakuna</span>
      </div>
      <div className="auth-split-bg">
        <div className="auth-split-left" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
          <form className="register-form" onSubmit={handleVerify} style={{ width: '100%', maxWidth: 350, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18 }}>
            <div className="auth-title">Verify Your Email</div>
            <div style={{ marginBottom: 12, color: '#555', fontSize: 15, textAlign: 'center' }}>
              Please enter the 6-digit OTP code sent to <b>{email}</b>.
            </div>
            <input
              className="auth-input"
              type="text"
              placeholder="Enter 6-digit OTP code"
              value={otp}
              onChange={e => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
              required
              maxLength={6}
              style={{ letterSpacing: 6, textAlign: 'center', fontSize: 22, width: '100%', marginBottom: 8 }}
            />
            <button className="auth-btn" type="submit" disabled={loading || otp.length !== 6} style={{ width: '100%' }}>
              {loading ? 'Verifying...' : 'Verify'}
            </button>
            {error && <div style={{ color: 'red', marginBottom: 10, fontWeight: 500, textAlign: 'center', background: '#fff3cd', border: '1px solid #ffeeba', borderRadius: 6, padding: 10, width: '100%' }}>{error}</div>}
            {success && <div style={{ color: '#19c37d', marginBottom: 10, fontWeight: 500, textAlign: 'center', background: '#e6fff4', border: '1px solid #19c37d', borderRadius: 6, padding: 10, width: '100%' }}>Registration complete! You may now log in.</div>}
            <div className="auth-footer" style={{ marginTop: 16, color: '#555', fontSize: 14, textAlign: 'center', width: '100%' }}>
              <b>Note:</b> Check your email for the OTP code. If you did not receive it, check your spam folder or request a new code.
            </div>
          </form>
        </div>
        <div className="auth-split-right">
          <div className="auth-hero-content">
            <h2>Secure your account with email verification.</h2>
            <p>Enter the OTP code sent to your email to complete your registration and access your GabaySakuna dashboard.</p>
            <img src="/hero-image.svg" alt="GabaySakuna Hero" className="auth-hero-img" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyOtp; 